// extracted by mini-css-extract-plugin
export default {"formBody":"call-us_formBody__EUmyQ","labelRow":"call-us_labelRow__uHqfk","labelText":"call-us_labelText__JQz8T","formMessage":"call-us_formMessage__J3Aaq"};